import React from "react";

const Header = () => {
  return (
    <>
      <div className="topbar">
        <div className="container topbar-content">
          <div>
            (+91)-750 700 2346
          </div>

          <div>
            info@krisulaglobexim.com
          </div>

          <div>
            krisulaglobexim
          </div>
        </div>
      </div>

      <header className="header">
        <div className="container nav-wrapper">
          <div className="logo">
            <img
              src="https://krisulaglobexim.com/wp-content/uploads/2023/07/cropped-logo.png"
              alt="Logo"
            />
          </div>

          <nav>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>

              <li>
                <a href="/about">About Us</a>
              </li>

              <li>
                <a href="/products">Products</a>
              </li>

              <li>
                <a href="/contact">Contact Us</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;